import { HttpService } from "../../modules/shared/services/http.service";
import { 
  ChatRule, 
  ChatRuleCreateDto, 
  ChatRuleUpdateDto,
  ChatRuleResponse,
  ChatRuleLatestResponse,
  ChatRuleLog,
  ChatRuleLogCreateDto,
  ChatRuleLogUpdateDto,
  ChatRuleLogResponse
} from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Get latest chat rule
export const getLatestChatRule = async (): Promise<ChatRuleLatestResponse> => {
  const response = await HttpService.get("api/v1/chat-rules/latest", true, { "x-custom-lang": "en" });
  return response;
};

// Get all chat rules with pagination
export const getChatRules = async (query?: Record<string, string | number | boolean>): Promise<ChatRuleResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/chat-rules${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get chat rule by ID
export const getChatRuleById = async (id: string): Promise<ChatRule> => {
  const response = await HttpService.get(`api/v1/chat-rules/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

// Create new chat rule
export const createChatRuleAction = async (data: ChatRuleCreateDto): Promise<ChatRule> => {
  const response = await HttpService.post("api/v1/chat-rules", data, headers, true);
  return response;
};

// Update chat rule
export const updateChatRuleAction = async (id: string, data: ChatRuleUpdateDto): Promise<ChatRule> => {
  const response = await HttpService.patch(`api/v1/chat-rules/${id}`, data, headers, true);
  return response;
};

// Delete chat rule
export const deleteChatRuleAction = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/chat-rules/${id}`, { "x-custom-lang": "en" }, true);
};

// Chat Rule Logs Actions

// Create chat rule log
export const createChatRuleLogAction = async (data: ChatRuleLogCreateDto): Promise<ChatRuleLog> => {
  const response = await HttpService.post("api/v1/chat-rule-logs", data, headers, true);
  return response;
};

// Get all chat rule logs with pagination
export const getChatRuleLogs = async (query?: Record<string, string | number | boolean>): Promise<ChatRuleLogResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/chat-rule-logs${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get chat rule log by ID
export const getChatRuleLogById = async (id: string): Promise<ChatRuleLog> => {
  const response = await HttpService.get(`api/v1/chat-rule-logs/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

// Update chat rule log
export const updateChatRuleLogAction = async (id: string, data: ChatRuleLogUpdateDto): Promise<ChatRuleLog> => {
  const response = await HttpService.patch(`api/v1/chat-rule-logs/${id}`, data, headers, true);
  return response;
};

// Delete chat rule log
export const deleteChatRuleLogAction = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/chat-rule-logs/${id}`, { "x-custom-lang": "en" }, true);
};
